import { Injectable, signal } from '@angular/core';

export type Toast = { id: number; type: 'success' | 'error' | 'info'; message: string };

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _toasts = signal<Toast[]>([]);
  private idSeq = 1;

  toasts = this._toasts.asReadonly();

  success(message: string, timeoutMs = 3000) { this.push('success', message, timeoutMs); }
  error(message: string, timeoutMs = 4000) { this.push('error', message, timeoutMs); }
  info(message: string, timeoutMs = 3000) { this.push('info', message, timeoutMs); }

  private push(type: Toast['type'], message: string, timeoutMs: number) {
    const id = this.idSeq++;
    this._toasts.update(list => [...list, { id, type, message }]);
    setTimeout(() => this.dismiss(id), timeoutMs);
  }

  dismiss(id: number) {
    this._toasts.update(list => list.filter(t => t.id !== id));
  }
}

